import { useState, useEffect, Fragment } from "react";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { FieldEditControls } from "components/FieldEditControls/FieldEditControls";
import "./ImageRadioField.scss";

const ImageRadioField = (props: any) => {
  let {
    editable,
    label,
    editPath,
    onChange,
    options = [],
    defaultValue,
    name,
    mode
  }: any = props;

  const [value, setValue] = useState(defaultValue as any);
  const [isEditEnabled, setIsEditEnabled] = useState(false);


  const selectItem = (index: number) => {

    setValue(options[index].name);

  };
  useEffect(() => {
    if (onChange) {
      //console.log(value)
      onChange(value);
    }
  }, [value]);
  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  return (
    <div className="image-radio-field-container">
      <div className="field-header">
        {label && (
          <label>
            <span>{label}</span>
          </label>
        )}
        {(mode == 'edit' && editable) && (
          <FieldEditControls
            value={value}
            fieldName={name}
            editPath={editPath}
            onEditStart={() => {
              setIsEditEnabled(true);
            }}
            onEditCancel={(originalValue) => {
              setIsEditEnabled(false);
              setValue(originalValue);
            }}
            onEditEnd={(success: boolean, originalValue) => {
              setIsEditEnabled(false);
              if (!success) {
                setValue(originalValue);
              }
            }}
          />
        )}
      </div>
      <div className="field-body">
        <div>
          {mode == 'readonly' ||
            (mode == 'edit' && editable && !isEditEnabled) ||
            (mode == 'edit' && !editable) ? (
            <div className="readonly-item">
              <div>
                {options.find((item: any) => item.name === value) ? (
                  <div>

                    {options.find((item: any) => item.name === value).imageUrl && (
                      <div>
                        <img src={options.find((item: any) => item.name === value).imageUrl} alt="loading" width="100%" />
                      </div>
                    )}

                    <span>{options.find((item: any) => item.name === value).displayName}</span>
                  </div>
                ) : (
                  <span>-</span>
                )}
              </div>
            </div>

          ) : (
            <div className="editable-items">

              {options.map((item: any, index: number) => {
                const showInModes = item.showInModes || [];
                const shouldShowOption = showInModes.includes(mode);
                return (
                  <Fragment key={index}>
                    {shouldShowOption && (
                      <a
                        style={{ marginTop: "10px" }}
                        onClick={() => selectItem(index)}
                      >
                        {item.imageUrl && (

                          <img src={`${item.imageUrl}`} alt="loading" width="100%" />

                        )}
                        <span style={{ marginTop: "0px" }}>
                          {item.displayName}
                        </span>

                        <div style={{ borderRadius: "99px" }}>
                          {item.name == value ? (
                            <RadioButtonCheckedIcon color="primary" />
                          ) : (
                            <RadioButtonUncheckedIcon />
                          )}
                        </div>
                      </a>
                    )}
                  </Fragment>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export { ImageRadioField };
